export const toTitleCase = (str: string): string => {
  // Split the string by hyphens or underscores
  const words = str?.split(/[-_]/);

  // Capitalize the first letter of each word and join them with a space
  const convertedStr = words?.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

  return convertedStr || str;
};
